<div class="main__content">
  <p class="c11n-text-sm" data-cy="total-breadcrumb" [innerHTML]="buildDisplay()"></p>
</div>
